module.exports = __webpack_public_path__ + "static/media/808KnobLabel--tempo.b0edf90b.svg";